export const MARKETING_ANALYTICS_STORAGE_KEY = "optrixis_marketing_analytics_consent_v1";
export const MARKETING_LEAD_EVENT = "optrixis:marketing-lead-confirmed";
export type MarketingConsent = "accepted" | "declined";
export type MarketingFormName = "access" | "contact" | "demo" | "enterprise";

export function validGa4MeasurementId(value: unknown): value is string {
  return typeof value === "string" && /^G-[A-Z0-9]{6,20}$/.test(value);
}
export function savedMarketingConsent(value: string | null): MarketingConsent | null {
  return value === "accepted" || value === "declined" ? value : null;
}
export function isMarketingFormName(value: unknown): value is MarketingFormName {
  return value === "access" || value === "contact" || value === "demo" || value === "enterprise";
}
